exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#payment-deposit-accounts[data-v-641f08ec]{margin-top:80px}.page-title[data-v-641f08ec]{margin-bottom:20px}.table th[data-v-641f08ec]{border-top:none}.badge[data-v-641f08ec]{font-size:.75em}.btn-group .btn[data-v-641f08ec]{margin-right:2px}.btn-group .btn[data-v-641f08ec]:last-child{margin-right:0}.clickable-badge[data-v-641f08ec]{transition:all .2s ease}.clickable-badge[data-v-641f08ec]:hover{transform:scale(1.05);box-shadow:0 2px 4px rgba(0,0,0,.2)}", ""]);

// exports
